import { AxiosInstance, AxiosResponse } from "axios";
import VoiceMailFilterModel from "@/models/VoiceMailFilterModel";
import { VoiceMailModel } from "@/models/VoiceMailModel";
import Shared from "@/common/shared";
import TwilioWorkerModel from "@/models/TwilioWorkerModel";
import TwilioQueueModel from "@/models/TwilioQueueModel";
import { TwilioTaskModel } from "@/models/TwilioTaskModel";
import TwilioActivityModel from "@/models/TwilioActivitiesModel";
import TwilioTaskQueueModel from "@/models/TwilioTaskQueueModel";

export default class TwilioService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async getWorkers(companyId: number): Promise<TwilioWorkerModel[]> {
    const url = `/Twilio/${companyId}/workers`;
    const res: AxiosResponse<TwilioWorkerModel[]> = await this.axiosInstance.get<TwilioWorkerModel[]>(url);
    return res.data;
  }

  public async getTwilioQueues(companyId: number): Promise<TwilioQueueModel[]> {
    const url = `/Twilio/${companyId}/queues`;
    const res: AxiosResponse<TwilioQueueModel[]> = await this.axiosInstance.get<TwilioQueueModel[]>(url);
    return res.data;
  }

  public async cancelTwilioTask(companyId: number, task: TwilioTaskModel, reason: string): Promise<TwilioTaskModel> {
    const url = `/Twilio/${companyId}/cancel-task`;
    const res: AxiosResponse<TwilioTaskModel> = await this.axiosInstance.post<TwilioTaskModel>(url, {
      taskSid: task.sid,
      reason,
    });
    return res.data;
  }

  public async deleteTwilioTask(companyId: number, task: TwilioTaskModel): Promise<boolean> {
    const url = `/Twilio/${companyId}/task/${task.sid}`;
    const res: AxiosResponse<boolean> = await this.axiosInstance.delete<boolean>(url);
    return res.data;
  }

  public async getVoiceMails(data: VoiceMailFilterModel): Promise<VoiceMailModel[]> {
    const url = `/Twilio/voice-mails`;
    const res: AxiosResponse<VoiceMailModel[]> = await this.axiosInstance.post<VoiceMailModel[]>(url, data);
    if (res.status === 400) {
      const conflictError = new Error();
      conflictError.name = Shared.noTwilioSetup;
      return Promise.reject(conflictError);
    }
    return res.data;
  }

  public async changeActivity(companyId: number, activitySid: string, workerSid: string): Promise<void> {
    console.log("Inside ChangeActivity");
    const url = `/Twilio/${companyId}/change-activity/${activitySid}/${workerSid}`;
    const res: AxiosResponse = await this.axiosInstance.post(url, {
      compandId: companyId,
      activitySid: activitySid,
      workerSid: workerSid,
    });
  }

  public async getActivities(companyId: number): Promise<TwilioActivityModel[]> {
    const url = `/Twilio/${companyId}/get-activities`;
    const res: AxiosResponse<TwilioActivityModel[]> = await this.axiosInstance.get<TwilioActivityModel[]>(url);
    return res.data;
  }

  public async getQueues(companyId: number, workerSid: string): Promise<TwilioTaskQueueModel[]> {
    const url = `/Twilio/${companyId}/get-queues/${workerSid}`;
    const res: AxiosResponse<TwilioTaskQueueModel[]> = await this.axiosInstance.post<TwilioTaskQueueModel[]>(url, {
      workerSid: workerSid,
    });
    return res.data;
  }
}
